import { Navigation } from "@/components/Navigation";
import { AboutSection } from "@/components/AboutSection";
import { lazy, Suspense, useEffect, useState } from "react";
import { shouldOptimizeForMobile } from "@/lib/mobile-detection";

// Lazy load all heavy/below-fold components
const Hero = lazy(() => import("@/components/Hero").then(m => ({ default: m.Hero })));
const HeroMobile = lazy(() => import("@/components/HeroMobile").then(m => ({ default: m.HeroMobile })));
const Partners = lazy(() => import("@/components/Partners").then(m => ({ default: m.Partners })));
const Services = lazy(() => import("@/components/Services").then(m => ({ default: m.Services })));
const ServicesMobile = lazy(() => import("@/components/ServicesMobile").then(m => ({ default: m.ServicesMobile })));
const BroadcastFeature = lazy(() => import("@/components/BroadcastFeature").then(m => ({ default: m.BroadcastFeature })));
const BroadcastFeatureMobile = lazy(() => import("@/components/BroadcastFeatureMobile").then(m => ({ default: m.BroadcastFeatureMobile })));
const News = lazy(() => import("@/components/News").then(m => ({ default: m.News })));
const NewsMobile = lazy(() => import("@/components/NewsMobile").then(m => ({ default: m.NewsMobile })));
const FAQ = lazy(() => import("@/components/FAQ").then(m => ({ default: m.FAQ })));
const Footer = lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));

const ComponentLoader = () => (
  <div className="min-h-[30vh] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const Index = () => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    // Determine device type on mount
    setIsMobile(shouldOptimizeForMobile());

    const handleResize = () => {
      setIsMobile(shouldOptimizeForMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Show nothing until we know the device type to avoid hydration mismatch
  if (isMobile === null) {
    return <div className="min-h-screen bg-background" />;
  }

  return (
    <div className="min-h-screen">
      <Navigation />
      <main>
        <Suspense fallback={<ComponentLoader />}>
          {isMobile ? <HeroMobile /> : <Hero />}
        </Suspense>
        <AboutSection />
        <Suspense fallback={<ComponentLoader />}>
          <Partners />
        </Suspense>
        <Suspense fallback={<ComponentLoader />}>
          {isMobile ? <ServicesMobile /> : <Services />}
        </Suspense>
        <Suspense fallback={<ComponentLoader />}>
          {isMobile ? <BroadcastFeatureMobile /> : <BroadcastFeature />}
        </Suspense>
        <Suspense fallback={<ComponentLoader />}>
          {isMobile ? <NewsMobile /> : <News />}
        </Suspense>
        <Suspense fallback={<ComponentLoader />}>
          <FAQ />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
